import React, { useState, useEffect } from 'react'
import { history } from '../../_redux/_store/history'
import { useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import { editFindingRule } from '../../_redux/_actions/selectFindingRuleAction'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import CancelIcon from '@material-ui/icons/Cancel'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import queryString from "query-string";

const useStyles = makeStyles(() => ({
  Button: {
    width: '120px',
    marginRight: '20px',
    '&:hover': {
      background: '#52A1C2',
    },
  },
}))

export default function EditFindingRule({
  open,
  dataToEdit,
  onClose,
  setEditFindingSuccess,
  setEditFindingFailure,
}) {
  const classes = useStyles()
  const [editedRuleName, setEditedRuleName] = useState('')
  const [editedRuleDescription, setEditedRuleDescription] = useState('')
  const queryValues = queryString.parse(history.location.search);
  const {machine_type, hmi_type} = queryValues
  const dispatch = useDispatch()

  useEffect(() => {
  setEditedRuleName(dataToEdit.name)
  setEditedRuleDescription(dataToEdit.description)
  },[])
  
  // Edit the finding rule
  const updateRule = () => {
    const body = {
      id: dataToEdit.id,
      name: editedRuleName,
      description: editedRuleDescription,
    }
    dispatch(editFindingRule(dataToEdit.id, body,machine_type,hmi_type, handleEditFindingRule))
    onClose()
  }

  const handleEditFindingRule = (val) => {
    if (val) {
      setEditFindingSuccess(true)
    } else {
      setEditFindingFailure(true)
    }
  }

  return (
    <Grid>
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{ style: { width: '700px', height: '450px' } }}
      >
        <DialogContent style={{ overflow: 'hidden' }}>
          <Grid item container direction='column' justifyContent='center'>
            <Grid
              container
              direction='row'
              justifyContent='space-between'
              style={{ marginBottom: '2em', marginTop: '1em' }}
            >
              <Grid item>
                <Typography style={{ color: '#52A1C2', fontWeight: 700 }}>
                  Edit Finding Rule
                </Typography>
              </Grid>
              <Grid item>
                <Button onClick={onClose} className={classes.Button}>
                  <CancelIcon style={{ color: '#666666' }} />
                </Button>
              </Grid>
            </Grid>
            <Grid
              item
              style={{ marginBottom: '0.5em' }}
            >
              <TextField
                id='new_anomalyrule'
                label='Finding Rule Name'
                defaultValue={editedRuleName}
                variant='outlined'
                fullWidth
                onChange={(e) => setEditedRuleName(e.target.value)}
              />
            </Grid>
            <Grid
              item
              style={{ marginBottom: '0.5em' }}
            >
              <TextField
                multiline
                rows={7}
                defaultValue={editedRuleDescription}
                id='anomaly rule description'
                variant='outlined'
                fullWidth
                onChange={(e) => setEditedRuleDescription(e.target.value)}
              ></TextField>
            </Grid>
            <Grid container direction='row' style={{ marginBottom: '3em' }}>
              <Grid item>
                <Button
                  className={classes.Button}
                  onClick={() => {
                    updateRule()
                  }}
                >
                  Done
                </Button>
              </Grid>
              <Grid item>
                <Button className={classes.Button} onClick={onClose}>
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </Grid>
  )
}

{
  /* Pop up to show if the edit finding rule has been successful */
}
export const EditFindingRuleSuccess = ({ open, setEditFindingSuccess }) => {
  return (
    <Grid>
      <Dialog
        open={open}
        maxWidth={'md'}
        PaperProps={{ style: { width: '40em', height: '20em' } }}
      >
        <DialogContent style={{ padding: '30px' }}>
          <Grid
            item
            container
            direction='column'
            justifyContent='center'
            alignItems='center'
          >
            <Grid item>
              <CheckCircleOutlineIcon
                style={{ width: '3em', height: '3em', color: '#52A1C2' }}
              />
            </Grid>
            <Grid item style={{ marginTop: '20px', marginBottom: '20px' }}>
              Finding Rule has been edited successfully
            </Grid>
            <Grid item>
              <Button
                onClick={() => setEditFindingSuccess(false)}
                variant='outlined'
              >
                <Typography>OK</Typography>
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </Grid>
  )
}
